export default __webpack_public_path__ + "static/media/aircraft.998213d7.svg";